import { useLayoutEffect, useState } from 'react'

function useMediaQuery(query: string): boolean | undefined {
    const [matches, setMatches] = useState<boolean | undefined>(
        typeof window !== 'undefined' ? matchMedia(query).matches : undefined,
    )

    useLayoutEffect(() => {
        const media = window.matchMedia(query)
        if (media.matches !== matches) {
            setMatches(media.matches)
        }
        const listener = (): void => {
            setMatches(media.matches)
        }
        media.addEventListener('change', listener)
        return () => {
            media.removeEventListener('change', listener)
        }
    }, [matches, query])

    return matches
}

export { useMediaQuery }
